/* ATLAS — Effets premium : titres mot à mot, boutons aimantés, curseur, défilement fluide, logo du pied de page.
   Rien au-dessus de la ligne de flottaison n'en dépend ; tout s'arrête en mouvement réduit. */
(function () {
  'use strict';

  var html = document.documentElement;
  var flags = (html.getAttribute('data-lx') || '').split(/\s+/);
  var on = function (f) { return flags.indexOf(f) !== -1; };
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  html.classList.add('lx-on');

  /* ---------- Titres : les mots montent quand la section arrive ---------- */
  function split(el) {
    if (el.__lx || el.closest('.atlas-sheen, .rte, [data-lx-nosplit]') || el.classList.contains('atlas-sheen')) return;
    if ((el.textContent || '').trim().split(/\s+/).length > 14) return;
    el.__lx = true;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(/ /.test(part) ? ' ' : ' ')); return; }
            var w = document.createElement('span');
            var wi = document.createElement('span');
            w.className = 'lx-w';
            wi.className = 'lx-wi';
            wi.style.setProperty('--i', i++);
            wi.textContent = part;
            w.appendChild(wi);
            frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && !/^(BR|SVG|IMG)$/i.test(child.tagName)) {
          walk(child);
        }
      });
    })(el);
    el.classList.add('lx-split');
    io.observe(el);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('lx-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 }) : null;

  function initSplit(scope) {
    if (!on('split') || !io) return;
    /* Le titre du hero porte le LCP : il reste tel quel */
    scope.querySelectorAll('main h2, main .atl-display:not(h1)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.85) return;
      split(el);
    });
  }

  /* ---------- Boutons : texte qui roule + léger aimant (souris seulement) ---------- */
  function initButtons(scope) {
    if (!fine || !on('magnetic')) return;
    scope.querySelectorAll('.atl-btn, .product-form__submit').forEach(function (b) {
      if (b.__lx) return;
      b.__lx = true;
      if (b.children.length === 0 && b.textContent.trim()) {
        var label = b.textContent.trim();
        b.textContent = '';
        var roll = document.createElement('span');
        roll.className = 'lx-roll';
        roll.setAttribute('data-text', label);
        var inner = document.createElement('span');
        inner.textContent = label;
        roll.appendChild(inner);
        b.appendChild(roll);
        b.setAttribute('aria-label', label);
      }
      b.classList.add('lx-mag');
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.setProperty('--mx', ((e.clientX - r.left) / r.width - 0.5) * 10 + 'px');
        b.style.setProperty('--my', ((e.clientY - r.top) / r.height - 0.5) * 8 + 'px');
      });
      b.addEventListener('pointerleave', function () { b.style.setProperty('--mx', '0px'); b.style.setProperty('--my', '0px'); });
    });
  }

  /* ---------- Curseur (souris seulement) ---------- */
  function initCursor() {
    var c = document.querySelector('.lx-cursor');
    if (!fine || !on('cursor') || !c) return;
    html.classList.add('lx-cursor-on');
    var label = c.querySelector('.lx-cursor__label');
    var x = innerWidth / 2, y = innerHeight / 2, cx = x, cy = y;
    window.addEventListener('pointermove', function (e) { x = e.clientX; y = e.clientY; c.classList.remove('is-away'); }, { passive: true });
    document.addEventListener('pointerleave', function () { c.classList.add('is-away'); });
    document.addEventListener('pointerdown', function () { c.classList.add('is-down'); });
    document.addEventListener('pointerup', function () { c.classList.remove('is-down'); });
    document.addEventListener('pointerover', function (e) {
      var t = e.target;
      var card = t.closest && t.closest('.card-wrapper, .atl-card, .atl-bb__card, .product-media-container');
      var link = t.closest && t.closest('a, button, label, select, [role="button"]');
      var text = t.closest && t.closest('input, textarea');
      c.classList.toggle('is-label', !!card);
      c.classList.toggle('is-link', !card && !!link);
      c.classList.toggle('is-text', !!text);
      label.textContent = card ? c.dataset.view : '';
    });
    (function loop() {
      cx += (x - cx) * 0.2;
      cy += (y - cy) * 0.2;
      c.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Défilement fluide à la molette (ordinateur) ---------- */
  function initSmooth() {
    if (!fine || !on('smooth')) return;
    var target = window.scrollY, pos = target, running = false;
    function step() {
      pos += (target - pos) * 0.12;
      if (Math.abs(target - pos) < 0.5) { pos = target; running = false; }
      window.scrollTo(0, pos);
      if (running) requestAnimationFrame(step);
    }
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.defaultPrevented || document.body.style.position === 'fixed' || document.querySelector('dialog[open], .sg-modal-open, body.overflow-hidden, body.overflow-hidden-tablet, body.overflow-hidden-mobile')) return;
      for (var n = e.target; n && n !== document.body; n = n.parentElement) {
        var s = getComputedStyle(n);
        if (/(auto|scroll)/.test(s.overflowY) && n.scrollHeight > n.clientHeight) return;
      }
      e.preventDefault();
      if (!running) { pos = window.scrollY; target = pos; }
      var delta = e.deltaMode === 1 ? e.deltaY * 32 : e.deltaY;
      target = Math.max(0, Math.min(target + delta, document.documentElement.scrollHeight - innerHeight));
      if (!running) { running = true; requestAnimationFrame(step); }
    }, { passive: false });
    window.addEventListener('scroll', function () { if (!running) { pos = target = window.scrollY; } }, { passive: true });
  }

  /* ---------- Logo ATLAS du pied de page qui se remplit d'or ---------- */
  function initWordmark() {
    var wm = document.querySelector('[data-lx-wordmark]');
    if (!wm || !on('wordmark')) return;
    var ticking = false;
    function draw() {
      ticking = false;
      var r = wm.getBoundingClientRect();
      var p = Math.min(Math.max((innerHeight - r.top) / (r.height * 1.6), 0), 1);
      wm.style.setProperty('--lx-fill', p.toFixed(3));
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(draw); } }, { passive: true });
    draw();
  }

  /* ---------- Transitions : la photo du produit cliqué glisse jusqu'à sa fiche ---------- */
  function initTransitions() {
    if (!on('transitions')) return;
    var clear = function () {
      html.classList.remove('lx-vt-card');
      document.querySelectorAll('img[style*="view-transition-name"]').forEach(function (img) { img.style.viewTransitionName = ''; });
    };
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!a || a.target === '_blank') return;
      var card = a.closest('.card-wrapper, .atl-card, .atl-bb__card');
      var img = card && card.querySelector('img');
      if (!img) return;
      clear();
      /* Un seul élément peut porter ce nom : la photo de la fiche actuelle le cède à la carte */
      html.classList.add('lx-vt-card');
      img.style.viewTransitionName = 'lx-product';
    });
    /* Retour arrière : la page revient du cache telle quelle, on retire le nom */
    window.addEventListener('pageshow', clear);
  }

  function boot() {
    initSplit(document);
    initButtons(document);
    initCursor();
    initSmooth();
    initWordmark();
    initTransitions();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { initSplit(e.target); initButtons(e.target); });
})();
